var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715364083182,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9726,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M820 400.9V262c0-30.7-25.1-55.5-56-55.5H120c-30.9 0-56 24.9-56 55.5v361c0 30.7 25.1 55.5 56 55.5h504v-222c0-30.7 25.1-55.5 56-55.5h140z m102.8 56.2H714.2c-20.5 0-37.2 16.9-37.2 37.7v285c0 20.8 16.7 37.7 37.2 37.7h208.6c20.5 0 37.2-16.9 37.2-37.7v-285c0-20.8-16.7-37.7-37.2-37.7z m-55.5 305.1h-94.9c-4.9 0-8.9-6.2-8.9-13.9s4-13.9 8.9-13.9h94.9c4.9 0 8.9 6.2 8.9 13.9s-4 13.9-8.9 13.9zM568 762H288c-15.5 0-28 12.4-28 27.8 0 15.3 12.5 27.8 28 27.8h280c15.5 0 28-12.4 28-27.8S583.5 762 568 762z",
    fill: "#ffffff",
    "p-id": 9727
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantform);
export default __webpack_public_path__ + "static/media/plantform.6ffabe865fe01dd62429ecf64f4fc424.svg";
export { ForwardRef as ReactComponent };